import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class ChartService {
  contractBaseUrl;

  constructor(private http: HttpClient, private userService: UserService) {
    this.contractBaseUrl = environment.contractApiURL + "/user/" +
      this.userService.loggedinUser.id + '/tenants/' + this.userService.loggedinUser.tenantId;
  }
  
  getContractStatus() {
    return this.http.get(this.contractBaseUrl + '/contractsByStatusForGraphs')
  }

  getContractByType() {
    return this.http.get(this.contractBaseUrl + '/contractsByTypeForGraphs')

  }
  getContractByTranc() {
    return this.http.get(this.contractBaseUrl + '/contractsByTrascTypeForGraphs')

  }
 
}
